import { useTranslation } from 'react-i18next';
import React, { useEffect, useState,useContext } from "react";
import { Table } from "antd";
import { YhBox } from "@/erp_subpackage/components/YhBox";
import { YhPageHeader } from "@/erp_subpackage/components/YhPageHeader";
import {useContractModel} from '../contractParticularsModel'
import {usecontractDetailsModel} from './detailsModel'
import { formatNum } from '@/erp_subpackage/utils/util';
import { getCurrentCurrencySymbol } from '@/utils/currencyUtils';



export const MileageOneTable = () => {
    const {t} = useTranslation()
    const {setOpen}=useContractModel()
    const  {loading,billdetailData,mileageOrderdetailes,serachmdetail,descTotalt,updateSearchParamm,resetSearchParamm
    } =usecontractDetailsModel()


    useEffect(()=>{
        setOpen(false)
    })
const column2=[
    {
        title:  t(`contractManagement.view.MileageOneTable.对账单单号`),
        width: 140,
        dataIndex: 'billCode',
        fixed: "left",
    },
    {
        title:  t(`contractManagement.view.MileageOneTable.车辆牌照`),
        width: 100,
        dataIndex: 'vehicleCode',
        
    },
    {
        title:  t(`contractManagement.view.MileageOneTable.上月账单里程`),
        width: 120,
        dataIndex: 'mileageLast',
        
        title:  t(`contractManagement.view.MileageOneTable.当前里程`),
        width: 120,
        dataIndex: 'mileageCurrent',
       
    },
    {
        title:  t(`contractManagement.view.MileageOneTable.运行里程`),
        width: 150,
        dataIndex: 'threeGuaranteesBrand',
    }, {
        title:  t(`contractManagement.view.MileageOneTable.计费价格`),
        width: 100,
        dataIndex: 'billPrice',
        render:(text)=>text.toFixed(3)
    }, {
        title:  t(`contractManagement.view.MileageOneTable.账单金额`),
        width: 100,
        dataIndex: 'hourlyWage',   
    }, {
        title:  t(`contractManagement.view.MileageOneTable.已收金额`),
        width: 100,
        dataIndex: 'paidAmount',
      
    },{
        title:  t(`contractManagement.view.MileageOneTable.应收金额`),
        width: 100,
        dataIndex: 'payableAmount',
       
        
    },
    {
        title:  t(`contractManagement.view.MileageOneTable.开始日期`),
        width: 100,
        dataIndex: 'mealSupplement',
        
    },
    {
        title:  t(`contractManagement.view.MileageOneTable.结束日期`),
        width: 100,
        dataIndex: 'mealSupplement',
       
        
    },
   
]

const searchFields1 = [ 
    {
        type: "Input",
        placeholder:  t(`contractManagement.view.MileageOneTable.车辆牌照`),
        fieldName: "vehicleCode"
    }, 
]




const desc1 = [
    {
        label:  t(`contractManagement.view.MileageOneTable.费用金额`),
       value: getCurrentCurrencySymbol() + (descTotalt.totalAmount?? 0).toFixed(2),
        color: "red"
    },
    {
        label:  t(`contractManagement.view.MileageOneTable.已收金额`), 
        value: getCurrentCurrencySymbol() + (descTotalt.paidAmount?? 0).toFixed(2),
        color: "red"
    }, {
        label:  t(`contractManagement.view.MileageOneTable.应收金额`),
        
     value: getCurrentCurrencySymbol() + (descTotalt.payableAmount?? 0).toFixed(2),
        color: "red"
    },
    
]

return (
    <>
         
            <YhBox descriptions={desc1} title={<span style={{fontSize:'14px'}}> { t(`contractManagement.view.MileageOneTable.对账单里程明细`)}</span>}>
            <YhPageHeader
               size="small"
               justify="start"
               triggerSearch
               searchValues={serachmdetail}
               searchFields={searchFields1}
               onChange={updateSearchParamm}
               handleSearch={() => { mileageOrderdetailes({ ...serachmdetail,}) }}
               handleReset={resetSearchParamm}
            />
            <div>
            <Table
                columns={column2}  
                loading={loading} 
                dataSource={billdetailData}
                // pagination={{
                //     ...pgCfgt,
                //     position: ["bottomCenter"],
                //     showTotal: () => `共${pgCfgt.total}条`,
                //     onChange: (pageNum, pageSize) => {
                //         contractPageT({ pageNum, pageSize });
                //     }
                // }}
                scroll={{ y:800 }} 
            />
            </div>
            </YhBox>
          
    </>    
 
)

}